import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { FullUser } from '../../models/full-user.model';
import { MyProfileSummaryFacade } from './my-profile-summary.facade';

@Component({
  selector: 'app-my-profile-summary',
  templateUrl: './my-profile-summary.component.html',
  styleUrls: ['./my-profile-summary.component.css'],
  providers: [MyProfileSummaryFacade]
})
export class MyProfileSummaryComponent implements OnChanges, OnDestroy {
  @Input() user: FullUser;
  @Input() active = true;
  private languageChange: Subscription;

  constructor(public summary: MyProfileSummaryFacade, translate: TranslateService) {
    this.languageChange = translate.onLangChange.subscribe(() => this.summary.refreshTrainingNames());
  }

  ngOnChanges(): void {
    if (this.user && this.active) { this.summary.load(this.user); }
  }

  ngOnDestroy(): void { this.languageChange.unsubscribe(); }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-profile/my-profile-summary.component.ts